import styled, {
  createGlobalStyle,
  css,
} from 'styled-components';

export const Flex = css`
  display: flex;
`;

export const FlexCol = css`
  display: flex;
  flex-direction: column;
`;

export const FlexRowCenter = css`
  ${Flex};
  justify-content: center;
  align-items: center;
`;

export const FlexRowStart = css`
  ${Flex};
  justify-content: flex-start;
  align-items: center;
`;

export const FlexRowEnd = css`
  ${Flex};
  justify-content: flex-end;
  align-items: center;
`;

export const FlexRowBetween = css`
  ${Flex}
  justify-content: space-between;
  align-items: center;
`;

export const FlexRowAround = css`
  ${Flex}
  justify-content: space-around;
  align-items: center;
`;

export const FlexColCenter = css`
  ${FlexCol};
  ${FlexRowCenter}
`;

export const FlexColStart = css`
  ${FlexCol};
  justify-content: flex-start;
  align-items: flex-start;
`;

export const FlexColEnd = css`
  ${FlexCol};
  justify-content: flex-end;
  align-items: flex-end;
`;

export const FlexColBetween = css`
  ${FlexCol};
  justify-content: space-between;
  align-items: baseline;
`;

export const BackgroundCover = css`
  ${'' /* background-image: url(${props =>
    props.bgUrl && props.bgUrl});
  background-position: center;
  background-size: cover;
  background-repeat: no-repeat; */}
`;

export const BackgroundContain = css`
  ${BackgroundCover};
  background-size: contain;
`;

export const LoadingWrapper = styled.div`
  width: 100%;
  height: 100%;
  ${FlexRowCenter};
`;

export const MainContent = styled.div`
  height: calc(100vh - 68px);
`;

export const Container = styled.div`
  /* max-width: 100% !important; */
  width: 100%;
  padding: 16px 27px 0;
  @media (min-width: 768px) and (max-width: 1180px) {
    padding: 0 16px;
  }
`;

/* istanbul ignore next */
export const GlobalStyle = createGlobalStyle`
    :root {
        --color-theme: #2C62CC;
        --color-neutral-05: #DDE4F2;
        --color-green: #2EC26A;
        --color-blue: #007AFF;
        --color-yellow: #F0C330;
        --color-red: #E54D42;
        --color-smoke: #969FA7;
        --color-dark: #212121;
        --color-dark-2: #393839;
        --color-dark-3: #191919;
        --color-light: #F5F4F3;
        --color-not-selected: #8EA2C8;
        --color-text: #011233;
        --color-text-head: #2F497C;
        --color-background: #F8FAFC;
        --color-background-head: #DDE4F2;
        --color-border: #DBE2F0;
        --color-button: #F5F4F3;
        --color-button-hover: #F5F4F3;
        --color-button-border: #F5F4F3;
        --color-button-primary: #dc2626;
        --color-button-primary-hover: #dc2626;
        --color-button-primary-border: #dc2626;
        --color-button-primary-text: #FFFFFF;
        --color-box-shadow: 0 0 0 2px rgba(44, 98, 204, 0.2);
        --transition-smooth: all 0.5s cubic-bezier(0.04, 1, 0.6, 0.97);
        --transition-smooth-2: all 1.5s cubic-bezier(0.04, 1, 0.6, 0.97);
        --button-height: 38px;
        --button-md-height: 32px;
        --button-sm-height: 28px;
        --fontSize-h1: 32px;
        --fontSize-h2: 28px;
        --fontSize-h3: 24px;
        --fontSize-h4: 20px;
        --fontSize-h5: 16px;
        --button-border-radius: 6px;
    }
    ${'' /* * {
    user-select: none;
  } */}
    /* input {
      user-select: initial;
    } */
    small {
        font-size: 12px;
    }
    ${
            '' /* .eHlCMj {
    pointer-events: initial;
  } 
  *{
    margin: 0;
    padding: 0;
    pointer-events: initial !important;
  }*/
    }
    * {
        margin: 0;
        padding: 0;
    }

    html,
    body {
        height: 100%;
        width: 100%;
        color: var(--color-text);
        background: var(--color-background);
        font-size: 12px;
        line-height: 1.5;
        font-family: 'Roboto', 'Helvetica Neue', Helvetica, Arial, sans-serif;
    }

    body.fontLoaded {
        font-family: 'Inter', 'Roboto', 'Helvetica Neue', Helvetica, Arial, sans-serif;
    }

    h1, .h1 {
        font-size: var(--fontSize-h1);
    }

    h2, .h2 {
        font-size: var(--fontSize-h2);
    }

    h3, .h3 {
        font-size: var(--fontSize-h3);
    }

    h4, .h4 {
        font-size: var(--fontSize-h4);
    }

    h5, .h5 {
        font-size: var(--fontSize-h5);
    }

    p,
    label {
        line-height: 1.5em;
    }

    /* input, select, button {
      font-family: inherit;
      font-size: inherit;
    } */

    ui, li {
        padding-left: 0;
        margin-bottom: 0;
        list-style: none;
    }

    .fullWidth {
        width: 100% !important;
    }

    .fullHeight {
        height: 100% !important;
    }

    .export-excel-btn {
        color: #FFFFFF !important;
        background: #071528 !important;
        gap: 10px !important;
        width: 142px;
        height: 44px;
        border-radius: 10px;
    }

    .create-btn {
        color: #FFFFFF !important;
        background: #DA251D !important;
        gap: 10px;
        width: 189px;
        height: 44px;
        border-radius: 10px;
    }

    .common-select {
        width: 176px !important;
        height: 44px !important;
        border-radius: 10px !important;
        border: 1px !important;
        padding: 7px 12px 7px 12px;
        gap: 10px !important;
    }

    .filter-box {
        margin-bottom: 16px !important;
        width: 100% !important;
        height: 76px !important;
        border-radius: 16px;
    }

    .searchBox {
        flex: 1 1 260px;
        border-radius: 10px;
        border: 1px;
        height: 44px;
        padding: 10px 16px 10px 16px;
    }

    .page-info {
        margin-bottom: 16px;
    }

    .ant-table .ant-table-thead > tr > th {
        background: #F1F5F9 !important;
        color: #64748B !important;
        height: 56px;
        padding: 8px 16px 8px 16px;
        border-inline-end: none !important;
    }

    /* .icon {
      width: 1.5rem;
      height: 1.5rem;
    } */

    #root {
        width: 100%;
        height: 100%;
    }

    ::-webkit-scrollbar {
        background: transparent;
        width: 5px;
        height: 5px;
    }

    ::-webkit-scrollbar-thumb {
        border-radius: 9px;
        background: #c8c8c8;
    }

    ::-webkit-scrollbar-thumb:hover {
        background: rgb(136, 136, 136);
    }
`;
